<template>
    <svg xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        :fill="fillColor" 
        :class="svgClass" 
        viewBox="0 0 16 16"
    >
        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
    </svg>
</template>
  
  
<script setup>
import { defineProps, computed } from 'vue';
    
const props = defineProps(['fill', 'iconClass'])

const fillColor = computed(() => {
    return props.fill? props.fill: 'black'
})

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : 'w-2.5 h-2.5'
})

</script>